module.exports = __webpack_public_path__ + "static/media/client_expenses_preview.3207567e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client_expenses_preview.png
// module id = 7315
// module chunks = 0